import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID} from '@angular/core';
registerLocaleData(localeFr, 'fr');

import { AppRoutingModule } from './app-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutModule } from '@angular/cdk/layout';



import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AuthrolebasedGuard } from './guard/authrolebased.guard'


import { environment } from '../environments/environment';

import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthGuard, canActivate, loggedIn } from '@angular/fire/auth-guard';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule, AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestoreModule, AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';


import { PresenceService } from './services/presence.service';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AdminComponent } from './admin/admin.component';
import { HttpClientModule } from '@angular/common/http';
import { UserCreationModalComponent } from './user-creation-modal/user-creation-modal.component';

import { PromptModalComponent } from './prompt-modal/prompt-modal.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { GroupCreationModalComponent } from './group-creation-modal/group-creation-modal.component';
import { KioskComponent } from './modules/kiosk/kiosk.component';
import { FormComponent } from './modules/form/form.component';
import { DataComponent } from './modules/data/data.component';



import { QuizComponent } from './modules/quiz/quiz.component';

import { UpdateUserEmailComponent } from './modals/user-modal/update-user-email.component';
import { DialogToolbarComponent } from './toolbar/dialog-toolbar.component';
import { QuizOptionsComponent } from './modals/quiz-options/quiz-options.component';
import { SettingsGlobalComponent } from './settings-global/settings-global.component';
import { ModalUploadBackgroundComponent } from './modals/modal-upload-background/modal-upload-background.component';
import { ShellComponent } from './shared/shell/shell.component';
import { ModalMainComponent } from './modals/modal-main/modal-main.component';
import { HomeComponent } from './home/home.component';
import { LotteryComponent } from './modules/lottery/lottery/lottery.component';
import { NgxMaterialTimepickerModule, NgxTimepickerFieldComponent } from 'ngx-material-timepicker';
import { MediaComponent } from './modules/media/media.component';
import { TreefileComponent } from './shared/treefile/treefile.component';
import { ModalMoveToComponent } from './modals/modal-move-to/modal-move-to.component';

import { FileNamePipe } from './shared/pipes/file-name.pipe';
import { TypeIconPipe } from './shared/pipes/type-icon.pipe';
import { MapFileNamePïpe} from './shared/pipes/mapFileName.pipe';
import { SafePipe } from './shared/pipes/safe.pipe';

import { ListSelectionModalComponent } from './modals/list-selection-modal/list-selection-modal.component';
import { ProgressbarmodalComponent } from './modals/progressbarmodal/progressbarmodal.component';
import { FileThumbnailComponent } from './modules/media/file-thumbnail/file-thumbnail.component';
import { TagsmanagementComponent } from './modals/tagsmanagement/tagsmanagement.component';
import { ContentListComponent } from './modules/media/content-list/content-list.component';
import { ModalTextComponent } from './modals/modal-text/modal-text.component';
import { ModalChangelogComponent } from './modals/modal-changelog/modal-changelog.component';

import { StatisticsModule } from './modules/statistics/statistics.module';
import { AccountmanagementModule } from './modules/accountmanagement/accountmanagement.module'
import { DateManagementComponent } from './modals/date-management/date-management.component';
import { UserCardComponent } from './admin/user-card/user-card.component';
import { AudioImportComponent } from './modules/lottery/audio-import/audio-import.component';
import { UsermanagementModule } from './modules/usermanagement/usermanagement.module';
import { RegisterModule } from './modules/register/register.module';
import { SharedModule } from './shared/shared/shared.module';
import { DataDisplayComponent } from './custom-components/bpi/data-display/data-display.component';
import { UserlistComponent } from './modals/userlist/userlist.component';
import { WaitingComponent } from './modals/waiting/waiting.component';
import { LotteryContainerComponent } from './modules/lottery/lottery-container/lottery-container.component';
import { ImageDisplayComponent } from './modals/image-display/image-display.component'
import { TranslationPipe } from './shared/pipes/translation.pipe';
import { TableComponent } from './modules/data/components/table/table.component';
import { TableElementComponent } from './modules/data/components/table-element/table-element.component';
import { ListSelectDeviceComponent } from './modals/list-select-device/list-select-device.component';
import { ModalEmailComponent } from './modals/modal-email/modal-email.component';
import { BackgroundConfigurationComponent } from './settings-global/background-configuration/background-configuration.component';
import { ModalTextInputComponent } from './modals/modal-text-input/modal-text-input.component';
import { SplitBackgroundComponent } from './settings-global/split-background/split-background.component';
import { LoginComponent } from './login/login.component';
import { SvginteractmodalComponent } from './modals/svginteractmodal/svginteractmodal.component';
import { EmailContentTutorialComponent } from './modals/email-content-tutorial/email-content-tutorial/email-content-tutorial.component';
import { ModalCustomLockComponent } from './modals/modal-custom-lock/modal-custom-lock.component';
import { QuestionListComponent } from './modules/quiz/question-list/question-list.component';
import { FloatingAddQuestionComponent } from './modules/quiz/floating-add-question/floating-add-question.component';
import { ModalTabComponent } from './modals/modal-tab/modal-tab.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ToolbarComponent,
        AdminComponent,
        UserCreationModalComponent,
        PromptModalComponent,
        QuizOptionsComponent,
        ConfirmModalComponent,
        GroupCreationModalComponent,
        KioskComponent,
        FormComponent,
        DataComponent,
        QuizComponent,
        UpdateUserEmailComponent,
        DialogToolbarComponent,
        QuizOptionsComponent,
        SettingsGlobalComponent,
        ModalUploadBackgroundComponent,
        ShellComponent,
        ModalMainComponent,
        HomeComponent,
        LotteryComponent,
        MediaComponent,
        TreefileComponent,
        ModalMoveToComponent,
        TypeIconPipe,
        FileNamePipe,
        MapFileNamePïpe,
        ListSelectionModalComponent,
        ProgressbarmodalComponent,
        FileThumbnailComponent,
        SafePipe,
        TagsmanagementComponent,
        ContentListComponent,
        ModalTextComponent,
        ModalChangelogComponent,
        DateManagementComponent,
        UserCardComponent,
        AudioImportComponent,
        DataDisplayComponent,
        UserlistComponent,
        WaitingComponent,
        LotteryContainerComponent,
        ImageDisplayComponent,
        TableComponent,
        TableElementComponent,
        ListSelectDeviceComponent,
        ModalEmailComponent,
        BackgroundConfigurationComponent,
        ModalTextInputComponent,
        SplitBackgroundComponent,
        SvginteractmodalComponent,
        EmailContentTutorialComponent,
        ModalCustomLockComponent,
    QuestionListComponent,
    FloatingAddQuestionComponent,
    ModalTabComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        AppRoutingModule,
        FlexLayoutModule,
        BrowserAnimationsModule,
        LayoutModule,
        FlexLayoutModule,
        ColorPickerModule,
        HttpClientModule,
        NgxMaterialTimepickerModule,
        StatisticsModule,
        AccountmanagementModule,
        UsermanagementModule,
        RegisterModule
    ],
    providers: [{ provide: LOCALE_ID, useValue: "fr-FR" }, MapFileNamePïpe, TypeIconPipe, PresenceService, AngularFireAuthGuard, AuthrolebasedGuard],
    bootstrap: [AppComponent]
})
export class AppModule { }
